// extracted by mini-css-extract-plugin
module.exports = {"Select":"Select_Select__B2zAh","isSelected":"Select_isSelected__WXRn4","Select__Placeholder":"Select_Select__Placeholder__aHrjD"};